export { BoundContentModule as ContentModule } from './components/ContentModule/ContentModule';
